<template>
  <div class="space">
    <div class="center">
      <div class="center-top">

        <div class="return" @click="repage"><img src="@/assets/images/return.png" alt="">返回上一步</div>
        <div class="step">
          <div :class="step == 0 ? 'item itemed' : 'item'">剧本创意</div>
          <div class="jt"><img v-show="step == 0" src="@/assets/images/jtl.png" alt=""><img v-show="step != 0"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 1 ? 'item itemed' : 'item'">剧情梗概</div>
          <div class="jt"><img v-show="step == 1" src="@/assets/images/jtl.png" alt=""><img v-show="step != 1"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 2 ? 'item itemed' : 'item'">分段脚本</div>
          <div class="jt"><img v-show="step == 2" src="@/assets/images/jtl.png" alt=""><img v-show="step != 2"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 3 ? 'item itemed' : 'item'">角色设计</div>
          <div class="jt"><img v-show="step == 3" src="@/assets/images/jtl.png" alt=""><img v-show="step != 3"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 4 ? 'item itemed' : 'item'">生成分镜</div>
        </div>
      </div>
      <div class="center-body">
        <div class="stepbox step5 custom-scrollbar">
          <div class="loading" v-if="loading">
            <div class="load1"><a-spin size="large" />
              <div class="js">正在生成分镜，请勿离开...</div>
            </div>
          </div>
          <div class="loaded" v-else>
            <div class="item" v-for="(item, index) in storyboards" :key="index">
              <div class="it1">
                <div class="it1_left">Part{{ index + 1 }} </div>
                <div class="it1_right">{{ item.segment_content }}</div>
              </div>
              <div class="it2">
                <div class="it2_img" v-for="(item2, index2) in item.items" :key="index2">
                  <img class="img" :src="item2" alt="">
                  <div class="download" @click="downloadImage(item2)"><img src="@/assets/images/load.png" alt=""></div>
                </div>
                <div class="it2_img imgadd">
                  <div class="loading2" v-if="item.loading">
                    <div class="load1"><a-spin size="large" />
                      <div class="js">正在生成分镜，请勿离开...</div>
                    </div>
                  </div>
                  <div v-else>
                    <img class="add1" src="@/assets/images/line_pic.png" alt="">
                    <div class="add2" @click="add(item.segment_id, index)">点击生成</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let timer = null
let timer2=null
import { mapActions } from "vuex"
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  data () {
    return {
      id: 0,
      step: 4,
      loading: true,
      loading2: false,
      storyboards: []
    }
  },
  async created () {
    this.id = this.$route.query.id
    if (this.$route.query.summary_id) {
      let res = await this.$http('api.getStobHis', {
        script_segment_id: this.$route.query.summary_id
      })
      if(res.data.has_pending_tasks){
        timer = setInterval(() => {
            this.getliststatus(res.data.pending_tasks[0].task_id)
          }, 5000);
        return
      }
      if (res.data.storyboards.length == 0) {

        let res2 = await this.$http('api.listStob', {
          script_segment_id: this.$route.query.summary_id,
          style: '写实'
        })
        if (res2.code != 1) {
          this.$router.go(-1)
        } else {
          // 开始轮询状态
          timer = setInterval(() => {
            this.getliststatus(res2.data.task_id)
          }, 5000);

        }
      } else {
        let arr = []
        res.data.storyboards.forEach(item => {
          item.loading = false
          arr.push(item)
        })
        this.storyboards = arr
        this.loading = false
      }

    }
  },
  mounted () {
    this.$bus.$emit('menu-active', false) // 关闭激活状态

  },
  destroyed(){
     clearInterval(timer)
  },
  methods: {
    ...mapActions("user", ["getUserInfo"]),
    // 获取队列任务生成状态
    async getliststatus (task_id) {
      let res = await this.$http('api.getStobStatus', {
        task_id
      })
      if (res.code != 1) {
        this.$router.go(-1)
        clearInterval(timer)
        return
      } else if (res.code == 1 && res.data.status == 'completed') {
        this.getUserInfo()
        clearInterval(timer)
        let arr = []
        res.data.storyboards.forEach(item => {
          item.loading = false
          arr.push(item)
        })
        this.storyboards = arr
        this.loading = false
      }else if(res.code==1&&res.data.status == 'failed'){
        this.$message.error('获取生成失败，请重试！')
        setTimeout(() => {
          this.$router.go(-1)
        clearInterval(timer)
        }, 1000);
      }

    },
    // 获取单独队列任务生成状态
    async getliststatus2 (task_id,index) {
      let res = await this.$http('api.getStobStatus', {
        task_id
      })
      if (res.code != 1) {
        clearInterval(timer2)
        return
      } else if (res.code == 1 && res.data.status == 'completed') {
        console.log(res.data.storyboards[0],'执行11111');
        
        this.getUserInfo()
        clearInterval(timer2)
        this.storyboards[index].items.push(res.data.storyboards[0].items[0])
        this.storyboards[index].loading = false
      }else if(res.code==1&&res.data.status == 'failed'){
        this.$message.error('生成失败，请重试！')
        clearInterval(timer2)
      }

    },
    async add (val, index) {
      this.storyboards[index].loading = true
      
      let res = await this.$http('api.listStob', {
          script_segment_id: this.$route.query.summary_id,
          segment_id: val,
          style: '写实'
        })
        if (res.code != 1) {
          this.storyboards[index].loading = false
        } else {
          // 开始轮询状态
          timer2 = setInterval(() => {
            this.getliststatus2(res.data.task_id,index)
            
          }, 5000);

        }
    },
    downloadImage (imgUrl) {
      const fileName = "my-image";
      const link = document.createElement("a");
      // 设置下载属性（文件名）
      link.download = fileName;
      // 设置图片 URL（处理跨域需特殊处理，见注意事项）
      link.href = imgUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 返回上一页
    repage () {
      this.$router.go(-1)
    },
  }
}
</script>
<style lang="scss" scoped>
.space {
  width: 100%;
  height: 100%;
  display: flex;

  .center {
    flex: 1;
    // padding: 20px;
    height: calc(100vh - 80px);

    .center-top {
      margin-top: 20px;
      height: 44px;
      position: relative;

      .return,
      .next {
        position: absolute;
        width: 134px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        top: 50%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DDDDDD;
        cursor: pointer;

        img {
          width: 20px;
          margin-right: 4px;
          transform: translateY(-2px);
        }
      }

      .return {
        left: 20px;
      }

      .next {
        right: 20px;
      }

      .step {
        margin: 0 auto;
        width: 620px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        box-shadow: 2px 2px 12px 0px rgba(97, 92, 92, 0.2);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #046DFA;
        display: flex;
        justify-content: center;

        .item {
          font-size: 18px;
          color: #595959;
        }

        .itemed {
          font-weight: bold;
          color: #046DFA;
        }

        .jt {
          margin: 0 16px;

          img {
            width: 16px;
          }
        }
      }
    }

    .center-body {
      margin: 0 auto;
      width: 100%;
      margin-top: 20px;
      height: calc(100vh - 180px);
      overflow: hidden;

      .stepbox {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

      }

      .step5 {
        margin: 0 auto;
        padding: 20px;
        overflow: auto;
        width: 96%;
        height: 100%;
        background: #F8F8F8;
        border-radius: 16px 16px 16px 16px;

        .loading {
          width: 100%;

          .load1 {
            width: 100%;
            text-align: center;
            margin-top: 200px;

            .js {
              margin-top: 20px;
            }
          }
        }

        .item {
          margin-bottom: 20px;
          border-bottom: 1px solid #DDDDDD;
          padding-bottom: 20px;

          .it1 {
            display: flex;

            .it1_left {
              font-size: 20px;
              color: #262626;
              width: 60px;
              height: 30px;
              line-height: 30px;
            }

            .it1_right {
              font-size: 14px;
              color: #262626;
              margin-top: 4px;
              flex: 1;
              margin-left: 10px;
            }
          }

          .it2 {
            margin-top: 20px;
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;

            .it2_img {

              width: 24%;
              height: 190px;
              border-radius: 12px;
              margin-right: 10px;
              margin-bottom: 20px;
              background: rgb(238, 238, 238);
              position: relative;
              overflow: hidden;

              .download {
                display: none;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;
                z-index: 2;
                width: 40px;
                height: 40px;
                text-align: center;
                background-color: #313131bd;
                border-radius: 4px;
                cursor: pointer;

                img {
                  // margin-left: 8px;
                  margin-top: 6px;
                  width: 24px;
                  height: 24px;
                }
              }

              .img {
                width: 100%;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }

            .it2_img:hover .download {
              display: block;
            }

            .imgadd {
              width: 24%;
              height: 190px;
              border-radius: 12px;
              margin-right: 10px;
              margin-bottom: 20px;
              background: rgb(241, 241, 241);
              position: relative;
              text-align: center;

              .loading2 {
                width: 100%;

                .load1 {
                  width: 100%;
                  text-align: center;
                  margin-top: 40px;

                  .js {
                    margin-top: 20px;
                  }
                }
              }

              .add1 {
                width: 42px;
                margin-top: 40px;
              }

              .add2 {
                cursor: pointer;
                margin: 0 auto;
                margin-top: 20px;
                width: 82px;
                height: 28px;
                background: #F8F8F8;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #DDDDDD;
              }
            }
          }


        }

        .item:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
